interface StarsDisplayProps {
  value: number;
  size?: 'sm' | 'md' | 'lg';
  showNumber?: boolean;
}

const sizeMap = {
  sm: 'text-[13px]',
  md: 'text-[16px]',
  lg: 'text-[22px]',
};

export default function StarsDisplay({ value, size = 'md', showNumber = false }: StarsDisplayProps) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;

  return (
    <span className="inline-flex items-center gap-1">
      <span className={`flex items-center gap-0.5 ${sizeMap[size]}`}>
        {Array.from({ length: 5 }, (_, i) => {
          if (i < full) {
            return (
              <i key={i} className="ri-star-fill text-accent-500" aria-hidden="true"></i>
            );
          }
          if (i === full && hasHalf) {
            return (
              <i key={i} className="ri-star-half-fill text-accent-500" aria-hidden="true"></i>
            );
          }
          return (
            <i key={i} className="ri-star-line text-background-300" aria-hidden="true"></i>
          );
        })}
      </span>
      {showNumber && (
        <span className="text-[13px] font-semibold text-foreground-700">{value.toFixed(1)}</span>
      )}
    </span>
  );
}